export const en = {
  name: 'English',
  export: 'Export',
  ok: 'OK',
  generics: {
    cancel: 'Cancel',
    send: 'Send',
    editMessagePlaceholder: 'Edit your message...',
    yes: 'Yes',
    no: 'No',
    noSelectionYet: ' No selection yet',
    to: ' to ',
    loading: 'Loading Data',
    reorder: 'Reorder',
    nothingToSee: 'Nothing to see here',
    noTransactions: 'No transactions occurred in this time frame.',
    card: 'Card',
    buttonHome: 'Go to Dashboard',
    go: 'Go',
  },
  exportOrder: {
    whatEmailExport: 'What email address should we send the data export to?',
    dataSent: 'Data export sent to',
    exportError: 'There was an error exporting the data.',
    format: 'Format',
    formatCsv: 'CSV',
    formatQbo: 'QBO',
    csvHelper: 'Standard export with all columns',
    qboHelper: 'QuickBooks Online-compatible CSV',
  },

  header: {
    signOut: 'Sign Out',
  },
  pagedConnectionTable: {
    previous: 'Previous',
    next: 'Next',
    pagination: 'Viewing %{curr}-%{all} of %{total} results',
  },
  timeSpan: {
    today: 'Today',
    aWeekAgo: 'a week ago',
    yesterday: 'Yesterday',
    theSameDay: 'the same day last week',
    lastWeek: 'Last Week',
    last7Days: 'Last 7 days',
    prevDays: 'the previous 7 days',
    thisWeek: 'This Week',
    samePeriod: 'the same period in the previous week',
    last30Days: 'Last 30 days',
    previous30Days: 'the previous 30 days',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    samePeriodLastMonth: 'the same period in the previous month',
    samePeriodLastYear: 'the same period last year',
    lastMonth: 'Last Month',
    thisQuarter: 'This Quarter',
    lastQuarter: 'Last Quarter',
    tomorrow: 'Tomorrow',
    next7Days: 'Next 7 days',
    nextWeek: 'Next Week',
    next30Days: 'Next 30 days',
    nextMonth: 'Next Month',
    nextQuarter: 'Next Quarter',
    custom: 'Custom',
    weekCountForward: {
      one: '%{count} week from now',
      other: '%{count} weeks from now',
    },
    weekCountBackward: {
      one: '%{count} week before',
      other: '%{count} weeks before',
    },
  },
  dateRange: '%{start} to %{end}',
  general: {
    filters: {
      search: 'Search name, phone, or email',
    },
    restaurantList: {
      only: 'Only',
      selectAll: 'Select All',
      done: 'Done',
      locations: '%{selectionLength} Locations',
      selectLocation: 'Select Location',
    },
    table: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      totalSpent: 'Total Spent',
      orders: 'Orders',
      marketingEmails: 'Marketing Emails',
      optedIn: 'Opted In',
      viewMore: 'View More',
    },
  },
  mainMenu: {
    chatHistory: 'Chat History',
    newAiChat: 'New AI Chat',
    preferences: 'Preferences',
    customers: 'Customers',
    employees: 'Employees',
    invoices: 'Invoices',
    aiAssistant: 'AI Assistant',
    payouts: 'Payouts',
    scheduledOrders: 'Scheduled Orders',
    scheduledOrdersDescription: 'Orders scheduled for today or thereafter',
    shifts: 'Shifts',
    salesSummary: 'Sales Summary',
    giftCards: 'Gift Cards',
    settings: 'Restaurant Settings',
    management: 'Management',
    allShifts: 'All Shifts',
    allEmployees: 'All Employees',
    allInvoices: 'All Invoices',
    allPayouts: 'All payouts',
    deleteChat: 'Delete',
    renameChat: 'Rename',
    loyalty: 'Loyalty',
  },
  scheduledOrders: {
    scheduledFor: 'Scheduled for %{range}',
    onDate: 'on %{date}',
    header: 'Scheduled for %{fulfillment} %{date} at %{time}',
    accept: 'Accept',
    reject: 'Reject',
    acceptPending: 'Accepting scheduled order...',
    rejectPending: 'Rejecting scheduled order...',
    acceptSuccess: 'Scheduled order accepted.',
    rejectSuccess: 'Scheduled order rejected.',
    acceptError: 'There was an error accepting the scheduled order.',
    rejectError: 'There was an error rejecting the scheduled order.',
    accepted: 'You accepted this order.',
    rejected: 'This order has been rejected.',
  },
  customers: {
    customers: 'Customers',
    marketingOptIn: 'Email Marketing Opt-in:',
    customerNotFound: "We couldn't find a customer with id",
    ohoh: 'Oh-oh',
    overview: 'Overview',
    daily: 'Daily',
    almostDaily: 'Almost Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    seldomly: 'Seldomly',
    firstOrder: 'First Order',
    lastOrder: 'Last Order',
    frequency: 'Frequency',
    averageSpent: 'Average Spent',
    orders: 'Orders',
    averageTip: 'Average Tip',
    totalSpent: 'Total Spent',
    itemName: 'Item Name',
    quantity: 'Quantity Sold',
    qty: 'Qty',
    totalSales: 'Total Sales',
    topItems: 'Top Items',
    loyalty: {
      heading: 'Loyalty',
      emptyTitle: 'Not enrolled in any loyalty programs',
      emptyDescription: 'This customer has not joined a loyalty program yet.',
      currentPoints: 'Current Points',
      currentPunches: 'Current Punches',
      availableRewards: 'Available Rewards',
      lifetimePoints: 'Lifetime Points',
      totalRedemptions: 'Total Redemptions',
      programDollar: 'Points per dollar',
      programItem: 'Virtual punch card',
      edit: 'Adjust',
      adjustTitle: 'Adjust Loyalty Balance',
      pointsAdjustment: 'Points Adjustment',
      punchesAdjustment: 'Punches Adjustment',
      reason: 'Reason',
      reasonPlaceholder: 'Why are you making this adjustment?',
      save: 'Save',
      cancel: 'Cancel',
      adjustSuccess: 'Loyalty balance updated.',
      historyTitle: 'History',
      historyEmpty: 'No loyalty activity yet.',
      colDate: 'Date',
      colType: 'Type',
      colChange: 'Change',
      colBalanceAfter: 'Balance After',
      colOrder: 'Order',
      colReward: 'Reward Redeemed',
      colActor: 'Operator',
      colReason: 'Reason',
      typeEarn: 'Earn',
      typeRedeem: 'Redeem',
      typeStarter: 'Starter',
      typeAdjustment: 'Adjustment',
      points: 'Points',
      punches: 'Punches',
      historyTruncated: 'Showing the most recent 50 transactions.',
      validationNonZero: 'Enter a non-zero change.',
      validationReason: 'Reason is required.',
      validationReasonTooLong: 'Reason must be 500 characters or fewer.',
      validationWouldGoNegative: 'Resulting balance cannot be below zero.',
    },
  },
  devices: {
    devices: 'Devices',
    subtitle:
      'Every iPad paired to this restaurant. Rename a device to make support triage easier.',
    nickname: 'Nickname',
    editNickname: 'Edit nickname',
    unnamedDevice: 'Unnamed device',
    renameFailed: 'Could not rename this device. Try again.',
    perDeviceCashDrawers: {
      label: 'One drawer per iPad',
      helper: 'Each iPad opens and closes its own drawer. When off, all iPads share one drawer.',
      on: 'On',
      off: 'Off',
      activeWarningTitle: 'A drawer is currently open',
      activeWarning: "There's an open drawer. The change will apply on the next open. Continue?",
      activeWarningConfirm: 'Continue',
      activeWarningCancel: 'Cancel',
      saveFailed: 'Could not update this setting. Try again.',
    },
    table: {
      title: 'All devices',
      nickname: 'Nickname',
      deviceName: 'Device name (iOS)',
      appVersion: 'App version',
      lastSeen: 'Last seen',
      status: 'Status',
      online: 'Online',
      offline: 'Offline',
    },
    detail: {
      deviceId: 'Device ID',
      settingsUpdatedAt: 'Settings last synced',
      editableHeading: 'Remote-editable settings',
      settingsHeading: 'Settings',
      cardPayments: {
        enabled: 'Use Card Reader',
        enabledGuidance:
          'Only affects iPads with a card reader already paired. New iPads still require physical Bluetooth setup at the location.',
        canCreateSetupIntents: 'Store cards to open tabs',
        canCreateSetupIntentsGuidance:
          'When on, tapping a card to open a tab saves the card on file so the tab can be closed without a second card tap.',
      },
      cashDrawer: { enabled: 'Enable Cash Drawer' },
      printing: {
        printTickets: 'Auto Print Tickets',
        printStickers: 'Auto Print Stickers',
        printReceipts: 'Enable Customer Receipts',
        printLogo: 'Avocado Logo',
      },
      kds: { enabled: 'Enable KDS' },
      kiosk: {
        enabled: 'Enable Kiosk Mode',
        acceptCash: 'Allow cash payments',
        requirePackaging: 'Require Packaging Selection',
        name: 'Kiosk name',
      },
      sounds: {
        newOnlineOrders: 'New Online Orders',
        newTickets: 'New Tickets',
        ticketReminders: 'Ticket Reminders',
        reminderFirstEnabled: 'Reminder 1',
        reminderFirstMinutes: 'Reminder 1 (min)',
        reminderSecondEnabled: 'Reminder 2',
        reminderSecondMinutes: 'Reminder 2 (min)',
        reminderThirdEnabled: 'Reminder 3',
        reminderThirdMinutes: 'Reminder 3 (min)',
      },
      giftCards: { enabled: 'Enable Gift Cards' },
      storefront: { enabled: 'Enable Storefront Controls' },
      tables: { enabled: 'Enable Tables' },
      tips: {
        enabled: 'Enable Tips',
        tipBeforePayment: 'Tip Before Payment',
        tipOnPaper: 'Tip on Paper Receipts',
        enableLargePartyTipScreen: 'Enable Additional Large Party Tips',
        showTipScreenEmployees: 'Show Clocked in Employees on Tip Screen',
      },
      checkout: {
        showAddCustomerScreen: 'Customer Name & Phone',
        enableTableMarkers: 'Table Marker',
        paymentLink: 'Payment Link',
      },
      viewDetails: 'View settings',
      settingHeader: 'Setting',
      valueHeader: 'Value',
      categoryHeader: 'Category',
      categories: {
        cardPayments: 'Card Payments',
        cashDrawer: 'Cash Drawer',
        checkout: 'Checkout',
        giftCards: 'Gift Cards',
        kds: 'KDS',
        kiosk: 'Kiosk',
        printing: 'Printer',
        sounds: 'Sounds',
        storefront: 'Storefront',
        tables: 'Tables',
        tips: 'Tips',
        pairing: 'Pairing',
        other: 'Other',
      },
      notFoundHeading: 'Device not found',
      notFoundBody:
        'No device with this ID is paired to the currently selected restaurant (%{restaurantName}). If you expected to find it, switch restaurants using the filter above.',
      errorHeading: 'Something went wrong',
      errorBody: 'We could not load this device. Try again in a moment.',
      saveFailed: 'Could not save device settings. Try again.',
      save: 'Save',
      saving: 'Saving…',
      discard: 'Discard',
    },
  },
  employees: {
    employees: 'Employees',
    employeeTable: {
      addEmployee: 'Add Employee',
      email: 'Email',
      name: 'Name',
      phone: 'Phone',
      location: 'Location',
      tippable: 'Tippable',
      clockInCode: 'Clock In Code',
      yes: 'Yes',
      no: 'No',
    },
    errors: {
      codeTaken: 'This code is already in use.',
      phoneTaken: 'This phone number is already in use.',
      unknownApiError: 'There was an error saving the employee.',
      emailTaken: 'This email is already in use by another employee.',
    },
    employeeAdded: 'Employee added.',
    employeeEdited: 'Employee edited',
    addEmployee: 'Add Employee',
    selectALocation: 'Select a Location',
    firstName: 'First Name',
    lastName: 'Last Name',
    clockInCode: 'Clock-in code (numbers only)',
    tippable: 'Tippable',
    deleteEmployee: 'Delete Employee',
    areYouSure: 'Are you sure you want to delete this employee?',
    editEmployee: 'Edit Employee',
    saveError: 'There was an error saving the employee.',
    saveSuccess: 'Employee saved.',
    createEmployee: 'Create Employee',
    invalidCode: 'Clock-in codes must be 4 digits.',
    deleteSuccess: 'Employee deleted.',
    deleteError: 'There was an error deleting the employee.',
  },
  permissions: {
    REPORTING: 'Can view this reporting dashboard',
    POS_AUTH: 'Can install the POS / KDS on new devices',
    REACTION_RECIPIENT: 'Receives SMS notifications with customer feedback',
    ACCOUNT_MANAGEMENT: 'Can manage compliance and bank accounts',
  },
  invoices: {
    invoices: 'Invoices',
    createInvoice: 'Create invoice',
    editInvoice: 'Edit invoice',
    paidInvoice: 'Paid invoice',
    invoicesTable: {
      createdDate: 'Created Date',
      customerEventName: 'Customer/Event Name',
      paymentStatus: 'Status',
      total: 'Total',
      eventDate: 'Event Date',
      stage: {
        depositDue: 'Deposit due',
        balanceDue: 'Balance due',
        overdue: 'Overdue',
      },
    },
  },
  forms: {
    fieldRequired: 'This field is required.',
    save: 'Save',
    emailInvalid: "That's not a valid email address.",
  },
  invoice: {
    invoice: 'Invoice',
    invoiceSaved: 'Invoice saved',
    invoiceDeleted: 'Invoice deleted',
    deleteInvoice: 'Delete',
    duplicateInvoice: 'Duplicate',
    yourBusinessDetails: 'Your business details',
    shownOnCustomerInvoice: "Shown on your customer's invoice",
    missingBusinessDetails: 'Some of your business details are missing.',
    goToSettings: 'Add them in settings',
    errorCreating: 'There was an error creating the invoice.',
    invoiceErrorFetching: 'There was an error fetching the invoice.',
    errorSaving: 'There was an error saving the invoice.',
    errorDeleting: 'There was an error deleting the invoice.',
    recordAPaymentFor: 'Record a payment for',
    selectARestaurant: 'Select a restaurant',
    customerOrEventName: 'Customer or Event Name',
    avocadoParty: 'Avocado Party for Instamenu',
    customerPhoneNumber: 'Customer Phone Number',
    customerEmail: 'Customer Email',
    phoneOrEmailRequired: 'Enter a phone number or an email address.',
    notValidPhoneNumber: "That's not a valid phone number.",
    notValidEmail: "That's not a valid email address.",
    item: 'Item',
    unit: 'Unit',
    price: 'Price',
    quantity: 'Quantity',
    tax: 'Tax',
    included: 'Included',
    amount: 'Amount',
    addAnItem: 'Add an item',
    itemName: 'Item Name',
    taxRefund: 'Tax Refund',
    hide: 'Hide',
    options: 'Options',
    customerExempt: 'This customer is tax exempt',
    customerExemptReason: 'Tax exemption reason',
    customerEIN: 'Customer EIN',
    payments: 'Payments',
    cash: 'Cash',
    achBankTransfer: 'ACH Bank Transfer',
    noPayments: 'No payments yet',
    balanceDue: 'Balance Due',
    recordACashPayment: 'Record a Cash Payment',
    sendPayableInvoice:
      'To send the payable invoice to your customer, text or email them this link:',
    urlCopied: 'URL copied to clipboard.',
    copy: 'Copy',
    errorCreatingPayment: 'There was an error creating the payment.',
    outstandingAmount: 'The total outstanding amount is %{amount} %{changeThisNumber}.',
    changeThisNumber: '.Change this number to record a partial payment.',
    payersName: "Payer's Name",
    firstName: 'First name',
    lastName: 'Last name',
    fullNameRequired: "Payer's full name is required.",
    payersEmail: "Payer's Email Address",
    payersEmailRequired: "Payer's email is required.",
    record: 'Record %{amount} %{payment}',
    payment: ' Payment',
    processingFee: 'Platform Fee',
    selectPaymentMethod: 'Select a payment method',
    paymentMethod: 'Payment Method',
    acceptTips: 'Accept tips',
    requireDeposit: 'Take a deposit',
    depositAmount: 'Deposit',
    depositDueNow: 'Deposit due now',
    depositInvalid: 'Enter a deposit between $0.50 and the invoice total.',
    eventDate: 'Event date',
    eventDateRequired: 'Add the event date so the customer knows when the balance is due.',
  },
  order: {
    servers: { zero: 'Servers', one: 'Server', other: 'Servers' },
    refund: {
      orderError: "We couldn't find an order with id %{id}.",
      ohoh: 'Oh-oh',
      items: 'Items',
      amount: 'Amount',
      selectAll: 'Select All',
      tip: 'Tip',
      processingFee: 'Platform Fee',
      canRefundUpTo: 'Can refund up to: %{total}',
      refundButton: 'Refund %{amount}',
      refundAndCancelButton: 'Refund and cancel %{amount}',
      enterAmount: 'Enter amount',
      notSoFast: ' Not so fast!',
      weCanHelp: ' We can help',
      notPaid: 'This order has not been paid yet.',
      alreadyIssued:
        'A refund for this order has already been issued. To issue additional refunds, please contact',
      supportMail: 'support@instamenu.cc',
      forAssistance: 'for assistance.',
      notFromDashboardPreviousDate:
        'Refunds from a previous date cannot be issued from the dashboard. To refund this order, please contact',
      notFromDashboard:
        'Cash orders cannot be refunded from the dashboard. To refund this order, please contact',
      multipleForms:
        'Orders with mulitple forms of payment cannot be refunded from the dashboard. To refund this order, please contact',
      orderHash: 'Order #',
      cannotBeIssued:
        'A refund for this order cannot be issued from the dashboard. To refund this order, please contact.',
    },
    order: 'Order',
    customerFeedBack: 'Customer Feedback',
    summary: 'Summary',
    largeParty: ' - Large Party',
    clockedIn: 'Clocked In: %{time}',
    receipt: 'Receipt',
    issueRefund: 'Issue Refund',
    cancelOrder: 'Cancel Order',
    cancelConfirm:
      'Are you sure you want to cancel this order? Any loyalty points will be restored.',
    duration: '%{duration} min',
    unpaid: 'Unpaid',
    tel: 'Tel: ',
    phoneCode: 'Phone code',
    mailto: 'Mailto: ',
    cashReceived: 'Cash Received',
    cashRounding: 'Cash rounding',
    cashRoundingRefunded: 'Cash rounding refunded',
    deliveryFee: 'Delivery Fee',
    loyaltyActivity: 'Loyalty activity',
    loyaltyAdjustment: 'Adjustment',
    loyaltyEarn: 'Earned',
    loyaltyRedeem: 'Redeemed',
    loyaltyStarter: 'Starter bonus',
    pointsEarned: { zero: 'points', one: 'point', other: 'points' },
    punchesEarned: { zero: 'punches', one: 'punch', other: 'punches' },
  },
  salesSummary: {
    salesSummary: 'Sales Summary',
    overview: {
      payout: 'Payout',
      orderTotalCollected: 'Order Total Collected',
      usingCash: 'Using Cash',
      usingCashDescription:
        'This is everything collected from the customer using cash, including cash-rounding adjustments, product sales, tax, and sales of gift cards. This does not include cash tips since the system is unaware of cash tips. This amount is not paid out since you already have the cash on hand.',
      usingThirdParty: 'Using 3rd Party',
      usingThirdPartyDescription:
        'Net order totals for connected third-party services during this period.',
      cashRounding: 'Cash rounding',
      cashRoundingDescription:
        'The signed net amount added to or removed from POS cash transactions when the amount collected was rounded to the nearest $0.05. It is already included in Total Collected and Using Cash. This is payment handling, not sales, a surcharge, or a discount.',
      usingGiftCards: 'Using Gift Cards',
      usingGiftCardsDescription:
        'This is all funds received from customers using gift cards including product sales, tax, and tip. The funds from gift cards were already received by you when selling the gift card.',
      salesTaxWithheld: 'Sales Tax Withheld',
      salesTaxWithheldDescription:
        'If you choose to have Avocado remit your Sales Tax for you, Sales Tax Withheld represents the amount withheld. If you do not choose to have us remit your taxes, this amount will be zero.',
      totalPayout: 'Total Payout',
      totalPayoutDescription:
        'Total Payout is the total amount that you should expect to receive through ACH or other means.',
      sales: 'Sales',
      grossSalesDescription:
        'Gross Sales is sales without discounts, refunds, or loyalty redemptions applied. This includes sales using credit cards, cash, and gift cards (sales where the guest uses a gift card to pay, but not when you sell a gift card). Gross Sales does not include sales tax or tip. Gross Sales includes surcharges and the original value of loyalty-redeemed items.',
      grossSalesCalc: 'Gross Sales = Credit/Debit Card Sales + Cash Sales + Sales Using Gift Cards',
      grossSales: 'Gross Sales',
      refunds: 'Refunds',
      refundsDescription:
        'Refunds is all debit/credit card and cash refunds. Purchases made with gift cards cannot be refunded.',
      discounts: 'Discounts',
      discountsDescription: 'This is the sum of all all item and order discounts.',
      loyalty: 'Loyalty',
      loyaltyDescription:
        'Value of items redeemed through the loyalty program. This amount is included in Gross Sales but deducted before Net Sales.',
      netSales: 'Net Sales',
      netSalesDescription:
        'Net Sales is Gross Sales minus Refunds, Discounts, and Loyalty. Net Sales does not include sales of gift cards.',
      netSalesCalc:
        'Net Sales = Credit Card Sales + Cash Sales + Sales Using Gift Cards - Discounts - Refunds - Loyalty',
      salesTax: 'Sales Tax',
      salesTaxDescription:
        'Sales Tax is the sales tax for all credit/debit card, cash, and gift card sales (sales using gift cards, not sales of gift cards. When using a gift card sales tax is applied, but when selling a gift card it is not applied.) Sales Tax is calculated on a per-transaction basis.',
      cardTips: 'Card Tips',
      cardTipsDescription:
        'Card Tips is the total tips from debit/credit cards and gift cards, but not cash since cash tips are not recorded through the system.',
      giftCardsSold: 'Gift Cards Sold',
      invoiceNetTotal: 'Paid Invoices',
      invoiceNetTotalDescription:
        'Paid Invoices is the money you collected from invoices during this period. It counts an invoice when it is paid, not when it is sent, so outstanding invoices are not included. Invoices are billed separately from orders, so this amount is not part of Gross Sales, Net Sales, or the Sales Total. It is included in Total Collected and in your Total Payout.',
      totalCollected: 'Total Collected',
      totalCollectedDescription:
        'The Total Collected is the sum of your Sales Total, Paid Invoices, Gift Cards Sold, and any Cash rounding adjustment.',
      salesTotal: 'Sales Total',
      salesTotalDescription:
        'The Sales Total is the sum of net sales, taxes, and tips. It does not include sales from invoices, the sale of gift cards, or the Avocado platform fee that is charged directly to the customer.',
      performance: 'Performance',
      transactions: 'Transactions',
      transactionsDescription:
        'Transactions is the total number of product and gift card transactions.',
      avgSale: 'Avg Sale',
      avgSaleDescription:
        'Average Sale is the average sale price including discounts and refunds, but not including tax or tip.',
      avgSaleCalc: 'Average Sale = Net Sales / Transactions',
      avgSaleCalcTwo:
        'Average Sale = (Credit Card Sales + Cash Sales + Sales Using Gift Cards - Discounts - Refunds) / Transactions',
      avgCardTip: 'Avg Card Tip',
      avgCardTipDescription:
        "Average Card Tip is the average tip for credit card orders. We do not include cash orders since the system does not know what cash tips are. We also don't include the gift card orders for this calculation.",
      instamenu: 'Fees paid by customers',
      processingFees: 'Platform Fees',
      processingFeesDescription:
        'Platform Fees are charged to customers and calculated on a per-transaction basis.',
      deliveryFees: 'Delivery Fees',
      deliveryFeesDescription:
        'Delivery Fees are fees charged directly to customers for the delivery of their order.',
      merchantFees: 'Merchant Fees',
      fromMerchant: '(From You)',
      merchantFeesDescription:
        'Merchant Fees is the fee charged to you. Merchant Fees are calculated on a per-transaction basis.',
      items: 'Items:',
      surcharges: 'Surcharges:',
      overview: 'Overview',
      upTo: ' up to %{time}',
    },
    customDateRange: {
      to: ' to %{date}',
      selectDateRange: 'Select a Date Range',
      done: 'Done',
    },
    customTimeRange: {
      to: 'to',
      allDay: 'All Day',
      start: 'Start',
      end: 'End',
      custom: 'Custom',
      done: 'Done',
    },
    dailySales: {
      dailySales: 'Daily Sales',
      comparedTo: ' compared to ',
      to: ' to %{date}',
      to2: '%{dateOne} to %{dateTwo}',
      netSales: 'Net Sales',
      tips: 'Tips',
    },
    topItems: {
      discount: 'Discounts',
      itemGroup: 'Category',
      itemName: 'Item Name',
      qty: 'Qty',
      quantitySold: 'Quantity Sold',
      sales: 'Sales',
      topItems: 'Top Items',
    },
    topAddons: {
      topAddons: 'Top Addons',
      quantitySold: 'Quantity Sold',
      qty: 'Qty',
      itemName: 'Item Name',
      sales: 'Sales',
    },
    orders: {
      orderId: 'Order ID',
      type: 'Type',
      refundUpper: 'REFUND',
      source: 'Source',
      location: 'Location',
      subtotal: 'Subtotal',
      netSales: 'Net Sales',
      tax: 'Tax',
      taxExemptWithNote: 'Tax Exempt (%{note})',
      taxExempt: 'Tax Exempt',
      includedTax: 'Included Tax',
      tip: 'Tip',
      deliveryTip: 'Driver Tip',
      processingFee: 'Platform Fee',
      total: 'Total',
      discounts: 'Discounts',
      giftCardInitialValue: 'Gift Card Initial Value',
      giftCardUsed: 'Gift Card Used',
      giftCardCode: 'Gift Card Code',
      transferAmount: 'Transfer Amount',
      customer: 'Customer',
      customers: 'Customers',
      note: 'Note',
      bonus: 'Bonus',
      refund: 'Refunded',
      discount: 'Discount',
      purchasedGiftCard: 'Purchased Gift Card %{code}',
      usedGiftCard: 'Used Gift Card',
      rewards: 'Rewards',
      rewardRedeemed: 'Reward redeemed',
      paidAt: 'Paid At',
      placedAt: 'Placed At',
      orders: 'Orders',
      collected: 'Collected %{amount}',
      included: 'Included',
      status: 'Status',
      scheduledAt: 'Scheduled for',
      delivery: 'Delivery',
      deliveryAddress: 'Delivery address',
      trackDelivery: 'Track Delivery',
      dropoffEta: 'Dropoff ETA',
      driver: 'Driver',
    },
  },
  shifts: {
    shifts: 'Shifts',
    addShift: 'Add Shift',
    totalByEmpAndLocation: 'Total by employee and location',
    employee: 'Employee',
    location: 'Location',
    totalDuration: 'Total Duration',
    totalTips: 'Total Tips',
    allShifts: 'All Shifts',
    start: 'Start',
    end: 'End',
    duration: 'Duration',
    tips: 'Tips',
    active: 'Active',
  },
  createShift: {
    selectAnEmployee: 'Select an Employee.',
    shiftsCanStart: 'Shifts can start after they end! 🤦‍♀️',
    shiftAdded: 'Shift added.',
    somethingWentWrong: 'Something went wrong.',
    createShift: 'Create Shift',
    noEmployees: 'This restaurant has no employees.',
    addEmployee: 'Add Employee',
    start: 'Start',
    end: 'End',
    selectADate: 'Select a Date',
    delete: 'Delete',
    update: 'Update',
    noId: "We couldn't find a shift with id ",
    shiftUpdated: 'Shift updated.',
    shiftDeleted: 'Shift deleted.',
    shiftAt: "'s shift at",
  },
  payouts: {
    payouts: 'Payouts',
    createPayout: 'Create payout',
    createPayoutDescription: 'Choose how you want to send your available balance.',
    selectRestaurant: 'Select a restaurant',
    payoutMethod: 'Payout method',
    standardPayout: 'Standard payout',
    standardPayoutDescription: 'Free and usually arrives in 1–3 business days.',
    instantPayout: 'Instant payout',
    currentlyUnavailable: 'Currently unavailable',
    instantPayoutDescription: 'Usually arrives within 30 minutes. A fee applies.',
    availableAmount: 'Available amount',
    estimatedFee: 'Estimated fee',
    estimatedDeposit: 'Estimated deposit',
    previewUnavailable: 'Instant payout is not available for this restaurant right now.',
    previewNoBalance: 'No settled balance is available for an instant payout yet.',
    previewDestinationMissing:
      'Add an eligible debit card to your Stripe account to receive instant payouts.',
    previewDailyLimit: 'This restaurant has reached its instant payout limit for today.',
    previewPaused: 'Payouts are temporarily paused. Try again later.',
    previewAccountMissing: 'Finish setting up your Stripe account before creating a payout.',
    previewFailed: 'We could not load the instant payout amount. Try again.',
    noManagedRestaurants:
      'You need account management permission for a restaurant to create a payout.',
    reviewPayout: 'Review payout',
    confirmPayout: 'Confirm payout',
    cancel: 'Cancel',
    standardConfirmation:
      'This will send the available balance as a free standard payout. It usually arrives in 1–3 business days.',
    instantConfirmation:
      'This will send an instant payout. The final application fee is confirmed by Stripe.',
    payoutCreated: 'Payout created.',
    payoutFailed: 'We could not create the payout. Try again.',
    ordersFrom: 'Orders From',
    location: 'Location',
    amount: 'Amount',
    status: 'Status',
    sentAt: 'Sent At',
    payoutHours: "We'll send your next payout for ",
    locations: 'locations',
    at: ' at ',
    and: ' and for ',
    for: ' for ',
    estimatedArrival: 'Payouts usually take 1-3 business days to arrive at your bank.',
  },
  aiAssistant: {
    newChat: 'New chat',
    notepad: 'Notepad',
    placeholder: 'Message Avocado AI',
    savedPromptHint: 'Tip: Save prompts you use often for quick access',
    savedPromptPlaceholder: 'Type a prompt...',
    save: 'Save',
    addSavedPrompt: 'Add Saved Prompt',
    loadingSavedPrompts: 'Loading saved prompts...',
    delete: 'Delete',
    removeSavedPrompt: 'Remove saved prompt',
    whatAreSavedPrompts: 'What are saved prompts?',
    reasoning: 'Reasoning',
    menuEditor: 'Menu editor',
    menu: 'Menu',
    restaurant: 'Restaurant',
    heroImage: 'Hero image',
    kioskImage: 'Kiosk background',
    logo: 'Logo',
    brandColor: 'Brand color',
    notepadPlaceholder: 'Both you and the AI can type here...',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Failed to copy',
    exportPdf: 'Export PDF',
    exportingPdf: 'Exporting…',
    notepadFilename: 'notepad.pdf',
    inStock: 'in stock',
    noLimit: 'No limit',
    outOfStock: 'Out of stock',
    hiddenOnline: 'Hidden online',
    variant: 'Variant',
    hidden: 'Hidden',
    addDescription: 'Add a description…',
    addCategory: 'Add category',
    addItem: 'Add item',
    addModifierGroup: 'Add modifier group',
    addModifier: 'Add modifier',
    newCategory: 'New Category',
    newItem: 'New Item',
    newModifierGroup: 'New Group',
    newModifier: 'New Modifier',
    count: 'Count',
    min: 'Min',
    max: 'Max',
    remove: 'Delete',
    modified: 'Modified',
    dropImage: 'Drop image',
    addImage: 'Add image',
    welcomeMessage:
      "Hi%{firstName}! I'm an AI that helps run your restaurant. You can talk to me just like ChatGPT, but I already know things about your restaurant and I can even *do things* like update your menu for you.",
    imageEdited: "Here's the edited image",
    menuSaveFailed: 'Could not save your menu changes. Please try again.',
    menuSaveFailedWithReason: 'Could not save your menu changes: %{reason}',
    menuNameFieldRequired: 'Name is required',
    menuNameRequired: 'Add a name to each new category, item, group, and modifier before you save.',
    settingsApproval: {
      title: 'Review settings changes',
      description:
        'The assistant staged the following changes. They will not take effect until you approve them.',
      approve: 'Approve',
      discard: 'Discard',
      applied: 'Settings updated',
      failed: 'Failed to save settings changes',
      on: 'On',
      off: 'Off',
      empty: '(empty)',
    },
    devicesApproval: {
      title: 'Review device changes',
      description:
        'The assistant staged changes for one or more devices. Nothing is applied until you approve each device below.',
      nickname: 'Nickname',
      approve: 'Approve',
      discard: 'Discard',
      applied: 'Device updated',
      failed: 'Failed to update device',
      staleAfterRetry:
        'Another update landed while this one was pending. Ask the assistant to re-read the device and try again.',
      on: 'On',
      off: 'Off',
      empty: '(empty)',
    },
    functionCalls: {
      image_generation: 'Generating an image',
      web_search: 'Searching the internet',
      query_database: 'Querying the database',
      evaluate_math_expression: 'Calculating results',
      read_menu: 'Studying the current menu',
      update_menu: 'Updating the menu',
      get_images: 'Looking at your menu images',
      read_restaurant: 'Reviewing information about your restaurant',
      update_restaurant: 'Updating your restaurant',
      confirm_restaurant_changes: 'Applying restaurant changes',
      get_restaurant_images: 'Looking at your restaurant images',
      get_notepad: 'Getting notepad content',
      set_notepad: 'Updating notepad',
      set_assistant_context: 'Saving assistant context',
      list_devices: 'Looking at your devices',
      read_device_settings: 'Reading device settings',
      update_device: 'Updating device',
    },
    resumeReport: 'Resume report',
    sqlRunStates: {
      starting: 'Starting',
      queued: 'Queued',
      generating: 'Preparing report',
      executing: 'Querying database',
      retrying: 'Retrying',
      succeeded: 'Completed',
      failed: 'Failed',
      canceled: 'Canceled',
      submitted: 'Completed',
    },
    functionCallStatus: {
      processing: 'Processing',
      ready: 'Ready',
      completed: 'Completed',
      error: 'Error',
    },
    suggestions: {
      title: 'Suggestions',
      improveWriting: 'Improve writing',
      correct: 'Correct',
      simplify: 'Simplify language',
      translate: 'Translate to…',
    },
    loadingPhrases: {
      intro: {
        understanding: 'Understanding the assignment',
        considering: 'Considering the possibilities',
      },
      funny: {
        marinating: 'Marinating Data Tables',
        restocking: 'Restocking Digital Pantries',
        simmering: 'Simmering Admin Settings',
        tenderizing: 'Tenderizing Server Responses',
        aligning: 'Aligning Menu Margins',
        whipping: 'Whipping Up Analytics',
        baking: 'Baking in Extra Features',
        greasing: 'Greasing Internet Pipes',
        slicing: 'Slicing and Dicing Metrics',
        proofing: 'Proofing Analytics Data',
        glazing: 'Glazing Over Reports',
        plating: 'Plating User Interfaces',
        rolling: 'Rolling Out New Menus',
        searing: 'Searing API Connections',
        fermenting: 'Fermenting Network Requests',
        salting: 'Salting Login Passwords',
        garnishing: 'Garnishing the Dashboard',
        paring: 'Paring Down Redundancies',
        seasoning: 'Seasoning Permissions Levels',
        brewing: 'Brewing Coffee for Admins',
        kneading: 'Kneading User Feedback',
        washing: 'Washing Dirty Dishes',
        organizing: 'Organizing Spice Racks',
      },
    },
  },
  giftCards: {
    giftCards: 'Gift Cards',
    code: 'Code',
    restaurantGroup: 'Restaurant Group',
    initialValue: 'Initial Value',
    balance: 'Balance',
    lastTransaction: 'Last Transaction',
    remainingBalance: 'Remaining balance: %{amount}',
    originalBalance: 'Original balance',
    purchased: 'Purchased',
    for: ' for',
    by: ' by',
    at: ' at %{restaurantName}',
    codeError: "We couldn't find a gift card with code %{code}.",
    order: 'Order',
    restaurant: 'Restaurant',
    date: 'Date',
    transactionHistory: 'Transaction History',
    giftCard: 'Gift Card',
  },
  loyalty: {
    settings: 'Settings',
    createProgram: 'Create program',
    setUpProgram: 'Set up loyalty program',
    updateProgram: 'Update program',
    programUpdated: 'Loyalty program updated',
    programCreated: 'Loyalty program created',
    saveFailed: 'Failed to save. Try again.',
    viewAnalytics: 'View analytics',
    noProgram: 'No loyalty program configured for this restaurant.',
    settingsEmptyTitle: 'No loyalty program yet',
    settingsEmptyDescription:
      'Reward your regulars and drive repeat visits. Set up a loyalty program to let customers earn points and redeem rewards.',
    // Config form
    statusActive: 'Active',
    statusInactive: 'Inactive',
    sectionProgramDetails: 'Program details',
    programNameLabel: 'Program name',
    programNamePlaceholder: 'e.g. Rewards program',
    programNameRequired: 'Program name is required',
    sectionEarningRules: 'Earning rules',
    mustBeAtLeast1: 'Must be at least 1',
    starterPointsLabel: 'Starter points',
    noItemGroupsFound: 'No item groups found',
    allItemGroups: 'All',
    sectionRewards: 'Rewards',
    rewardItemGroupsLabel: 'Reward item groups',
    sectionDisplayNotifications: 'Display & notifications',
    smsProgressEnabledLabel: 'Send SMS progress updates',
    sectionMessaging: 'Messaging',
    welcomeMessageLabel: 'Welcome message',
    welcomeMessageHint:
      "Use {displayName}, {pointsPerDollar}, and {earningThreshold} — they will be replaced with your program's values.",
    welcomeDefaultPoints:
      'Welcome to {displayName}! 🎉\nEarn {pointsPerDollar} points per $1 — rewards start fast.\nYour next order gets you closer 👀',
    welcomeDefaultPunch:
      'Welcome to {displayName}! 🎉\nBuy {earningThreshold}, get 1 free.\nYou start earning now 👀',
    rewardEarnedMessageLabel: 'Reward earned message',
    rewardEarnedMessageHint: 'Use {restaurant} — it will be replaced with your restaurant name.',
    rewardEarnedDefaultPoints:
      "🎉 You've earned a free item at {restaurant}!\nGet it online or at our store. 😏",
    rewardEarnedDefaultPunch:
      "🎉 You've earned a free item at {restaurant}!\nGet it online or at our store. 😏",
    progressMessageLabel: 'Progress message',
    progressMessageHint:
      "Use {progress} and {remaining} — they will be replaced with the customer's actual values.",
    progressDefaultPoints:
      'You have {progress} points at {restaurant}! Keep getting closer to your favorite items 🍜',
    progressDefaultPunch:
      '{progress} of {remaining} punches at {restaurant} — {remaining} more to earn a free item! 🍜',
    cancelButton: 'Cancel',
    confirmChangesTitle: 'These changes will affect existing customers',
    confirmChangesButton: 'Save changes',
    confirmChangeDeactivate:
      '• Deactivating the program — customers will no longer earn or redeem points',
    confirmChangeActivate:
      '• Reactivating the program — customers will start earning and redeeming again',
    confirmChangeEarningType:
      '• Changing the earning type — current points are saved, but customers start at 0 on the new type',
    confirmChangePointsPerDollar:
      '• Changing points per dollar — affects how fast customers earn rewards',
    confirmChangeEarningThreshold:
      '• Changing punches required — affects when customers earn a reward',
    confirmChangeEarningItems:
      '• Changing which items earn points — affects what counts toward rewards',
    confirmChangeRewardItems: '• Changing redeemable items — affects what customers can redeem',
    // Earning type
    earningTypeLabel: 'Earning type',
    earningTypeDollar: 'Points per dollar',
    earningTypeDollarDescription: 'Customers earn points based on how much they spend',
    earningTypeItem: 'Virtual punch card',
    earningTypeItemDescription: 'Customers earn a punch for each qualifying item',
    earningTypeEnforcedBySibling:
      'Another location in this group already uses this earning type. All locations in a group share the same earning type so customer balances stay consistent.',
    // Dollar-based
    howItWorksDollarBased: 'Customers earn %{points} point(s) per dollar spent.',
    howItWorksDollarRedeem: 'Points can be redeemed for menu items based on their price.',
    pointsPerDollarLabel: 'Points per dollar',
    pointsPerDollarRequired: 'Points per dollar is required',
    effectiveDiscountRate: 'Effective discount rate: ~%{rate}% on redeemable items',
    // Item-based
    howItWorksItemBased: 'Customers earn 1 punch per qualifying item purchased.',
    howItWorksItemRedeem: 'After %{threshold} punches, they get a free item.',
    earningThresholdLabel: 'Punches for a reward',
    earningThresholdRequired: 'Punches required is required',
    earningItemGroupsLabel: 'Which items earn rewards',
    rewardIncludesModifiersLabel: 'Free item includes optional add-ons',
    rewardIncludesModifiersDescription:
      'Required choices (like size) are always included in the reward. Enable this to also cover optional add-ons like syrups, toppings, and extras.',
    // Default message templates (shown when creating a new program)
    defaultWelcomeDollar:
      'Welcome to %{name}! 🎉\nEarn %{pts} points per $1 — rewards start fast.\nYour next order gets you closer 👀',
    defaultWelcomeItem:
      'Welcome to %{name}! 🎉\nBuy %{threshold}, get 1 free.\nYou start earning now 👀',
    defaultRewardEarnedDollar:
      "🎉 You've earned a free item at %{restaurant}!\nGet it online or at our store. 😏",
    defaultRewardEarnedItem:
      "🎉 You've earned a free item at %{restaurant}!\nGet it online or at our store. 😏",
    defaultProgressDollar:
      'You have {progress} points at %{restaurant}! Keep getting closer to your favorite items 🍜',
    defaultProgressItem:
      '{progress} of %{threshold} punches at %{restaurant} — {remaining} more to earn a free item! 🍜',
    // Dashboard-only label for comped items on order receipts
    loyaltyReward: 'Loyalty Reward',
    // Analytics tab
    analytics: {
      _: 'Analytics',
      totalEnrolled: 'Total enrolled',
      newEnrollments: 'New enrollments',
      enrolled: 'Enrolled',
      activeMembers: 'Active members',
      rewardsRedeemed: 'Rewards redeemed',
      penetration: 'Enrollment rate',
      ofTransactions: 'of customers',
      dailyActivity: 'Daily activity',
      enrollments: 'Enrollments',
      redemptions: 'Redemptions',
      pointsEarned: 'Points earned',
      punchesEarned: 'Punches earned',
      membersVsNonMembers: 'Members vs non-members',
      members: 'Members',
      nonMembers: 'Non-members',
      membersSpendMore: 'Members spend %{percent}% more per visit',
      memberRevenue: 'Member revenue',
      rewardCost: 'Reward cost',
      roi: 'Revenue per reward dollar',
      topCustomers: 'Top customers',
      visits: 'visits',
      rewards: 'rewards',
      overview: 'Overview',
      avgSpendMembers: 'Avg. spend (members)',
      avgSpendNonMembers: 'Avg. spend (non-members)',
      spendDifference: 'Spend difference',
      orders: 'Orders',
      avgSpend: 'Avg. spend',
      repeatRate: 'Repeat visit rate',
      repeatRateMembers: 'Repeat visit rate (members)',
      repeatRateNonMembers: 'Repeat visit rate (non-members)',
      rightAxis: 'right axis',
      errorTitle: 'Could not load analytics',
      noProgramTitle: 'No loyalty program',
      noProgramDescription: 'Set up a loyalty program to see analytics.',
      emptyTitle: 'No activity yet',
      emptyDescription: 'Once customers start enrolling, analytics will appear here.',
    },
  },
  unauthorized: {
    noAccess: 'This account does not have dashboard access. Please contact us at %{phone}.',
    signOut: 'Sign Out',
  },
  notFound: {
    dontExist: 'That page doesn´t exist. Return to the ',
    homePage: 'home page',
  },
  settings: {
    stripe: {
      defaultDisplayName: 'your business',
      title: 'Compliance and bank accounts',
      description: 'Modify your business information and manage bank accounts.',
      locations: 'locations',
      requirementsDue:
        'We need additional information about %{displayName} to continue sending payouts. Please provide this information as soon as possible.',
      onboardingSuccess:
        'Your account for %{displayName} is now active and ready to receive payments and payouts.',
      noAccounts: "You don't have access to manage external accounts.",
      edit: 'Edit',
      needsUpdate: 'Needs update',
    },
    restaurantSettings: {
      restaurantSettings: 'Restaurant Settings',
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
      tagline: 'Tagline',
      openingHours: 'Opening Hours',
      specialHours: 'Special Hours',
      nameOfTheSpecialHoursEvent: 'Name of the special hours event',
      save: 'Save',
      cancel: 'Cancel',
      taglinePlaceholder: 'Describe your restaurant in a few words',
      addressPlaceholder: '123 Main St, Anytown, USA',
      addSpecialHours: 'Add Special Hours',
      closed: 'Closed',
      to: 'to',
      phoneError: 'Please enter a valid phone number',
      restaurantNameRequired: 'Restaurant name is required',
      openingHoursError: 'Every shift must have a start and end time',
      weekday: {
        '1': 'Monday',
        '2': 'Tuesday',
        '3': 'Wednesday',
        '4': 'Thursday',
        '5': 'Friday',
        '6': 'Saturday',
        '7': 'Sunday',
      },
      settingsUpdatedSuccessfully: 'Settings updated!',
      nameRequired: 'Name is required',
      dateRequired: 'Date is required',
      incompleteOpeningPeriods: 'Please fill in all opening periods',
      dateAlreadyExists: 'A special hour already exists for this date',
      settingsUpdateFailed: 'Failed to update settings',
      openingHoursExceptionUpdateFailed: 'Failed to update opening hours exception',
      salesTax: 'Sales tax',
      cashRounding: 'Cash rounding',
      cashRoundingDescription:
        'Round only POS cash transactions to the nearest $0.05. Card, gift card, online, and invoice payments are not affected.',
      cashRoundingSaveFailed: 'Cash rounding could not be updated. Please try again.',
      banner: 'Banner',
      bannerPlaceholder: 'Something you would like to say to your customers',
      specialInstructions: 'Special instructions',
      enableSpecialInstructions:
        'Allow users to add special requests or instructions to items on online orders',
      scheduledOrders: 'Scheduled orders',
      enableScheduledOrders: 'Enable scheduled orders',
      minLeadMinutes: 'Minimum lead time (minutes)',
      minGrossSubtotal: 'Minimum order amount ($)',
      scheduledSlotLength: 'Scheduled slot interval length (minutes)',
      scheduledSlotLengthInvalid: 'Enter a positive multiple of 5',
      general: 'General',
      onlineOrdering: 'Online ordering',
      enableOnlineOrdering: 'Enable online ordering',
      hours: 'Hours',
      bankingAndCompliance: 'Banking & Compliance',
      devices: 'Devices',
      connectedDocuments: 'Documents',
      noStripeAccount1: 'Please contact us at ',
      noStripeAccount2: ' for help setting up your account.',
      noStripeAccountNoPhone: 'Please contact support for help setting up your account.',
      brandColor: 'Brand Color',
      restaurantGroupColorUpdateFailed: 'Failed to update restaurant group',
      restaurantGroupColorUpdated: 'Restaurant group updated',
      storefrontUrl: 'Storefront URL',
      copy: 'Copy',
      qrCodeAlt: 'Storefront QR code',
      downloadPng: 'Download PNG',
      downloadSvg: 'Download SVG',
      qrDownloadFailed: 'Could not generate QR download. Please try again.',
      copyUrl: 'Copy URL',
      close: 'Close',
      copied: 'Copied!',
      coverTitle: 'Cover Image',
      createWithAi: 'Create with AI',
      failedToEnhance: 'Failed to crop image with AI. Please try again.',
      failedToProcess: 'Failed to process image. Please try again.',
      zoom: 'Zoom',
      smartCrop: 'Smart Crop',
      logo: 'Logo',
      remove: 'Remove',
      kioskBackground: 'Kiosk Background Image',
      externalReviewUrl: 'External review URL',
      externalReviewUrlDescription:
        'Customers will be directed to this URL if they leave positive feedback on Avocado.',
      externalReviewUrlPlaceholder: 'https://g.page/r/your-restaurant/review',
      externalReviewUrlInvalid: 'Enter a valid HTTPS URL',
      externalReviewClickCount: 'Clicks: %{count}',
      aiAssistantMemory: 'AI Assistant Memory',
      aiAssistantMemoryDescription:
        'Allow the AI Assistant to remember details to provide better suggestions and assistance.',
      aiAssistantMemoryPlaceholder: '- We serve lunch from 12-3pm and dinner from 6-10pm.',
      aspectRatios: {
        logo: 'Logo',
        portrait: 'Portrait',
        kioskBackground: 'Kiosk Background',
        story: 'Story',
        cover: 'Cover',
      },
    },
  },
  selectLanguage: {
    selectLanguage: 'Select Language',
    english: 'English',
    spanish: 'Spanish',
    preferred: 'Select your preferred language.',
    defaultLanguage: ' Default language',
    languageSettings: 'Language',
  },
  paymentTypes: {
    CARD_MANUAL_ENTRY: 'Card (Manual Entry)',
    CARD_STORED: 'Card (Tab)',
    CARD_PRESENT: 'Card',
    CASH: 'Cash',
    EXTERNAL: 'External',
    GIFT_CARD: 'Gift Card',
    LEGACY_ONLINE: 'Mobile App',
    NO_PAYMENT: 'No Payment',
    US_BANK_ACCOUNT: 'US Bank Account',
    ONLINE: 'Online',
    REFUND: 'Refund', // the 'REFUND' case is not in the API, but used on the client to create an extra row in tables
    SPLIT: 'Split',
  },
  fulfillment: {
    DELIVERY: 'delivery',
    PICKUP: 'pickup',
  },
  status: {
    submitted: 'Submitted',
    deliveryAccepted: 'Driver accepted',
    pickupEnroute: 'Heading to Pickup',
    atPickup: 'At Pickup',
    dropoffEnroute: 'On the way to Deliver',
    delivered: 'Delivered',
    deliveryProblem: 'Delivery Problem',
    returned: 'Order Returned',
    deliveryCanceled: 'Delivery Canceled',
    unknown: 'Status Unknown',
    created: 'Created',
    placed: 'Placed',
    accepted: 'Accepted',
    completed: 'Completed',
    canceled: 'Canceled',
  },
  appErrors: {
    reloadLabel: 'Reload Page',
    retryLabel: 'Try again',
    newAppVersionDescription:
      'Facundo, Marvin, and Shayan have been busy on a new version of this site. Reload the page to get the latest version.',
    newAppVersionTitle: 'Yikes',
    unexpectedErrorDescription: 'Something broke unexpectedly.',
    unexpectedErrorTitle: 'Uh oh',
  },
  dropzone: {
    label: 'Drop your attachment here',
  },
};
